import { isSmallDevice } from 'src/modules/device';

const OFFSET = 32;
const MOBILE_HEADER_HEIGHT = 81;
const DESKTOP_HEADER_HEIGHT = 200;

const isCypressTest =
  typeof window !== 'undefined' && typeof window.Cypress !== 'undefined';

export const getScrollParams = () => {
  const isMobile = isSmallDevice();

  return {
    delay: !isCypressTest ? 10 : undefined,
    minDuration: !isCypressTest ? 400 : 1,
    duration: isCypressTest ? 1 : undefined,
    offset: OFFSET + (isMobile ? MOBILE_HEADER_HEIGHT : DESKTOP_HEADER_HEIGHT),
  };
};

export const resumeLimit = 10;
